import { ContactFormKeys } from 'pages/Contacts/schemas/contactSchema'
import { BeneficiaryDetails } from 'types/beneficiaries'
import { Contact, ContactInstrument, ContactPaymentInstruments, InstrumentType } from '../contacts'
import { CommonSheet } from '../types'

export interface ContactSheetMeta {
  contactFilter?: string[]
  contactInstrument?: ContactInstrument
  enableCreateInstrument?: boolean
  handleContactInstrumentUpdate?: (contactInstrument: ContactInstrument, contact?: Contact) => void
  handleContactSelect?: (contact: Contact) => void
  contactRequiredFields?: {
    requiredFields?: ContactFormKeys[]
    calloutMessage?: string
  }
  keepUpdatedContact?: boolean
  contactBeneficiary?: BeneficiaryDetails
  flowType?: InstrumentType
}

export interface ContactInstrumentSheetMeta {
  contactInstrument?: ContactInstrument
  enableCreateInstrument?: boolean
  handleContactInstrumentUpdate?: (contactInstrument: ContactInstrument, contact?: Contact) => void
  handleContactSelect?: (contact: Contact) => void
  flowType?: InstrumentType
  keepUpdatedPaymentInstrument?: boolean
  onPaymentInstrumentUpdate?: (paymentInstrument: ContactPaymentInstruments) => void
}

export const ContactActionIds = {
  CONTACT: 'CONTACT',
  CONTACT_ASSIGN: 'CONTACT_ASSIGN',
  MASSPAYOUTS: 'MASSPAYOUTS',
}

export type ContactActionId = (typeof ContactActionIds)[keyof typeof ContactActionIds]

export enum ContactAtomType {
  WALLET_ACTION = 'walletAction',
  CONTACT_ACTION = 'contactAction',
  CONTACT_INSTRUMENT_ACTION = 'contactInstrumentAction',
  MASS_PAYOUT_CONTACT_ACTION = 'massPayoutContactAction',
}

export const ContactInstrumentActionIds = {
  INSTRUMENT: 'INSTRUMENT',
  FIAT_INSTRUMENT: 'FIAT_INSTRUMENT',
  CONTACT_INSTRUMENT_DECISION: 'CONTACT_INSTRUMENT_DECISION',
}

export type ContactInstrumentActionId =
  (typeof ContactInstrumentActionIds)[keyof typeof ContactInstrumentActionIds]

export interface ContactActionSheet extends CommonSheet {
  actionId?: ContactActionId
  meta?: ContactSheetMeta
}

export interface ContactInstrumentActionSheet extends CommonSheet {
  actionId?: ContactInstrumentActionId
  meta?: ContactInstrumentSheetMeta
}
